const _sans = ["Noto Sans","ui-sans-serif","system-ui"]
const config = { "sans": _sans,  }
export { config as default, _sans }